import { render, staticRenderFns } from "./PaymentRequisitionApproverList.vue?vue&type=template&id=6e8588f9&"
import script from "./PaymentRequisitionApproverList.vue?vue&type=script&lang=ts&"
export * from "./PaymentRequisitionApproverList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports